import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { environment } from '../../environments/environment';
import { getStoredUser } from '../helpers/user-storage.util';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-address-verification-banner',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './address-verification-banner.component.html',
  styleUrl: './address-verification-banner.component.scss',
})
export class AddressVerificationBannerComponent {
  constructor(private authenticationService: AuthenticationService) {}

  get needsAddressVerification(): boolean {
    if (
      !environment.addressVerificationEnabled ||
      !this.authenticationService.isLoggedIn() ||
      this.authenticationService.isTokenExpired()
    ) {
      return false;
    }

    const user = getStoredUser();
    return user?.addressVerificationNeeded === true && user?.welcomeEmailPending !== true;
  }
}
